import { render, staticRenderFns } from "./BaseNotificationItem.vue?vue&type=template&id=b9daf23a&"
import script from "./BaseNotificationItem.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
